// Modules
export * from './lib/angular-shared-components.module';
export * from './lib/dashboard-grid/dashboard-grid.component';
// export * from './lib/editors/quill/quill.module';
export * from './lib/editors/trix/trix.module';

// Pipes.
export * from './pipes/json-format-pipe';
export { HatLocationPipe } from './lib/org-board/shared/hat-location.pipe';
export * from './lib/org-board/shared/part-location';

// Directives.
export * from './directives/resize-observer.directive';
export * from './directives/sheet-drag-dismiss.directive';

// Standalone Components.
export { WidgetSettingsDialogComponent } from './lib/dialogs/widget-settings-dialog/widget-settings-dialog.component';
export { ClientAbcGroupDialogComponent } from './lib/dialogs/client-abc-group-dialog/client-abc-group-dialog.component';
export { OrganizationBoardComponent } from './lib/org-board/organization-board.component';
export { OrgEditPositionDialogComponent } from './lib/org-board/dialogs/org-position-dialog/org-edit-position-dialog/org-edit-position-dialog.component';
export { SearchableSelectComponent } from './lib/searchable-select/searchable-select.component';

// Standalone Components (Dialogs).
export { ConfirmDialog } from './lib/dialogs/confirm.dialog';
export { PromptDialog, PromptDialogConfig, PromptDialogResult } from './lib/dialogs/prompt.dialog';
export { OrgHierarchyDialogComponent } from './lib/org-board/dialogs/org-position-dialog/org-hierarchy-dialog/org-hierarchy-dialog';
export { OrgReorderChildrenDialogComponent } from './lib/org-board/dialogs/org-reorder-children-dialog/org-reorder-children-dialog.component';
export { OrgMyPoliciesDialogComponent } from './lib/org-board/dialogs/org-my-policies-dialog/org-my-policies-dialog';
export {
    PolicyAcknowledgmentDialogComponent,
    PolicyAcknowledgmentDialogData,
    PolicyAcknowledgmentDialogResult,
} from './lib/org-board/dialogs/org-policy-acknowledgment-dialog/org-policy-acknowledgment-dialog';
export { OrgPolicyDetailsDialogComponent } from './lib/org-board/dialogs/org-policy-details-dialog/org-policy-details-dialog';
export {
    OrgPolicyViewerDialogComponent,
    PolicyViewerDialogData,
    PolicyViewerDialogResult,
} from './lib/org-board/dialogs/org-policy-viewer-dialog/org-policy-viewer-dialog';

// Standalone Services.
export { RightSideBarService } from './services/right-sidebar.service';
export { TreeBuilderService } from './services/tree-builder.service';
export { DialogService } from './services/dialog.service';
export { OrgDialogService } from './lib/org-board/services/org-dialog.service';
export { OrgBoardService } from './lib/org-board/services/org-board-service';
export { OrgBoardBuilderService } from './lib/org-board/services/org-board-builder.service';
export { OrgTree } from './lib/org-board/services/org-board-builder.service';
export { Position } from './lib/org-board/services/org-board-builder.service';
export { User } from './lib/org-board/classes/user.class';

// AI Services
export { PolicyAiService } from './lib/services/policy-ai.service';
export { PolicyAiDialogComponent } from './lib/org-board/dialogs/org-policy-dialog/policy-ai-dialog/policy-ai-dialog.component';

// Organization Dashboard
export { OrgDashboardGridComponent } from './lib/org-dashboard/org-dashboard-grid/org-dashboard-grid.component';
export type { OverviewTileClick } from './lib/org-dashboard/widgets/org-overview-widget/org-overview-widget.component';
export {
    OrgWidgetData,
    OrgWidgetMenuItem,
    OrgDashboardWidget,
    OrgWidgetType,
    OrgDashboardWidgetState,
    OrgWidgetEntity,
    OrgWidgetViewer,
    OrgLastChangedBy,
} from './lib/org-dashboard/models/org-widget.models';
export {
    computeTeamUids,
    isOrgAdminViewer,
    canSeeWidget,
    visibleWidgetTypes,
    activityVisibleToViewer,
} from './lib/org-dashboard/scope/dashboard-scope';

// Organization Entity Colors
export {
    OrgEntityColorsService,
    OrgEntityType,
    ResolvedEntityColors,
    DEFAULT_ENTITY_COLORS,
} from './lib/org-dashboard/services/org-entity-colors.service';
export {
    EntityColorPickerDialogComponent,
    EntityColorPickerDialogData,
    EntityColorPickerDialogResult,
} from './lib/org-dashboard/dialogs/entity-color-picker-dialog.component';

// Organization creation wizard (P1 — see docs/features/CREATE-ORGANIZATION-WIZARD-PLAN.md)
export { OrgCreationModule } from './lib/org-creation/org-creation.module';
export { OrgCreationWizardComponent } from './lib/org-creation/org-creation-wizard.component';
export { OrgDraftService } from './lib/org-creation/services/org-draft.service';
export { OrgCreationService } from './lib/org-creation/services/org-creation.service';
export { OrgWizardStateService } from './lib/org-creation/services/org-wizard-state.service';
export * from './lib/dashboard-grid/layout-grid/layout-grid.component';
export * from './lib/graph/target-pace';
export * from './lib/graph/graph-point';
export * from './lib/graph/graph-clock';
export * from './lib/graph/point-drawer/point-drawer.component';
